import { Component, Input, numberAttribute, signal } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-loader',
    standalone: true,
    imports: [MatProgressSpinner],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss',
})
export class LoaderComponent {
    @Input() set isLoading(value: boolean) {
        this.loading.set(value);
    }
    @Input({ transform: numberAttribute }) diameter: number = 100;

    loading = signal(true);
}
